'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaHddO = function FaHddO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.2 27.1q0 0.8-0.5 1.3t-1.3 0.5-1.2-0.5-0.6-1.3 0.6-1.2 1.2-0.5 1.3 0.5 0.5 1.2z m5.7 0q0 0.8-0.5 1.3t-1.3 0.5-1.2-0.5-0.5-1.3 0.5-1.2 1.2-0.5 1.3 0.5 0.5 1.2z m2.5 3.6v-7.1q0-0.3-0.2-0.5t-0.5-0.2h-27.1q-0.3 0-0.5 0.2t-0.2 0.5v7.1q0 0.3 0.2 0.5t0.5 0.2h27.1q0.3 0 0.5-0.2t0.2-0.5z m-27.4-10.7h26.3l-3.5-10.8q-0.1-0.2-0.4-0.4t-0.5-0.2h-17.5q-0.3 0-0.6 0.2t-0.3 0.4z m30.3 3.6v7.1q0 1.5-1.1 2.5t-2.5 1.1h-27.1q-1.5 0-2.6-1.1t-1-2.5v-7.1q0-0.6 0.4-1.7l4.4-13.5q0.3-1.2 1.4-2t2.2-0.7h17.5q1.2 0 2.2 0.7t1.4 2l4.4 13.5q0.4 1.1 0.4 1.7z' })
        )
    );
};

exports.default = FaHddO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/hdd-o.js
// module id = 1508
// module chunks = 0